import type { AxiosResponse } from 'axios';
import { http } from '@/services/http.service';
import { IUserLogin } from '@/types/general';

export const login = (user: IUserLogin): Promise<AxiosResponse> => {
  return http.post('users/login.json', { user });
};

export const logout = (): Promise<AxiosResponse> => {
  // Use full URL to avoid baseURL issues with /panel prefix
  return http.delete('/users/logout.json', { baseURL: '/' });
};

export const requestPasswordReset = (email: string): Promise<AxiosResponse> => {
  return http.post('users/password.json', { user: { email } });
};

export const resetPassword = (
  reset_password_token: string,
  password: string,
  password_confirmation: string,
): Promise<AxiosResponse> => {
  return http.put('users/password.json', {
    user: { reset_password_token, password, password_confirmation },
  });
};
